import { FormGroup } from "../../../components/form";
import * as Yup from "yup";

export const assignAssessorForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "assignedAssessorDetails",
      label: "Application Assigned to",
      fieldType: "dropdown",
      props: {
        placeholder: "Select an Assessor",
      },
      expressionProps: {
        options: (context) => context.options,
      },
      validation: Yup.mixed().required("A response is required"),
    },
  ],
};
